module.exports = __webpack_public_path__ + "img/14-2.984e0a15.jpg";